import styled from "styled-components";

export const MemoFieldStyle = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr; 
  gap: 1rem;
`;